// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback } from "react";
import { connect } from "react-redux";
import Link from "redux-first-router-link";

import {
  AppInfo as StyledAppInfo,
  InfoItem,
  OrgName,
  LogIn,
  WelcomeMessage,
  UnifizeLogo,
  DriveProcess,
  UnifizeIntro,
} from "./styles";
import EmailSent from "./EmailSent";
import EmailFailed from "./EmailFailed";
import LoadingState from "src/components/LoadingState";
import Icon from "src/icons";
import type { AppState } from "src/types";
import { getOrgName } from "src/reducers";
import { srwSignUp } from "src/actions/signup";
import { appDomain } from "src/config/firebase";

type Props = {
  orgName: string,
  currentUser: Object,
  path: string,
  canJoin: boolean,
  isExistingUser: boolean,
  _srwSignUp: Function,
  isVerificationEmailSent: boolean,
};

const AppInfo = ({
  orgName,
  currentUser,
  path,
  canJoin,
  isExistingUser,
  _srwSignUp,
  isVerificationEmailSent,
}: Props) => {
  const { displayName, email } = currentUser;

  const renderSection = useCallback(() => {
    if (isVerificationEmailSent === null)
      return (
        <>
          {(displayName || email) && (
            <WelcomeMessage>
              {i18n.t(k.WELCOME_BACK1)} {displayName || email.split("@")[0]}
              {i18n.t(k._32)}
              <br />
              {canJoin && (
                <>
                  {isExistingUser ? i18n.t(k.LOG_IN) : i18n.t(k.SIGN_UP)}{" "}
                  {i18n.t(k.TO_USE_THE_FULL)}
                </>
              )}
            </WelcomeMessage>
          )}

          {canJoin && (
            <>
              {isExistingUser ? (
                <Link to={`${appDomain}${path}`} target="_blank">
                  <LogIn>{i18n.t(k.LOG_IN1)}</LogIn>
                </Link>
              ) : (
                <LogIn onClick={_srwSignUp}>{i18n.t(k.SIGN_UP1)}</LogIn>
              )}
            </>
          )}
        </>
      );

    if (isVerificationEmailSent) return <EmailSent />;
    return <EmailFailed />;
  }, [
    i18n.language,
    displayName,
    email,
    isVerificationEmailSent,
    canJoin,
    isExistingUser,
    appDomain,
    path,
  ]);

  if (orgName)
    return (
      <StyledAppInfo>
        <div />
        <InfoItem>
          <OrgName>{orgName}</OrgName>
          {renderSection()}
        </InfoItem>
        <InfoItem>
          <UnifizeLogo>
            <Icon type="unifizeLogo" />
          </UnifizeLogo>
          <DriveProcess>
            {i18n.t(k.DRIVE_PROCESS_THROUGH_CONVERSA)}
          </DriveProcess>
          <UnifizeIntro>
            {i18n.t(k.UNIFIZE_INCREASES_YOUR_TEAM)}
            {`'`}
            {i18n.t(k.S_EFFICIENCY_BY_UP_TO_X_BY)}
          </UnifizeIntro>
        </InfoItem>
      </StyledAppInfo>
    );

  return <LoadingState type="info" />;
};

const mapStateToProps = ({
  app,
  location,
}: {
  app: AppState,
  location: Object,
}) => ({
  canJoin: app.canJoin,
  orgName: getOrgName(app, parseInt(app.orgs.last, 10)),
  currentUser: app.currentUser,
  path: location.pathname,
  isExistingUser: app.srw.isExistingUser,
  isVerificationEmailSent: app.srw.isVerificationEmailSent,
});

export default connect(mapStateToProps, {
  _srwSignUp: srwSignUp,
})(AppInfo);
